import { render, staticRenderFns } from "./UserAssigningTile.vue?vue&type=template&id=f54ea346&scoped=true&lang=pug&"
import script from "./UserAssigningTile.vue?vue&type=script&lang=js&"
export * from "./UserAssigningTile.vue?vue&type=script&lang=js&"
import style0 from "./UserAssigningTile.vue?vue&type=style&index=0&id=f54ea346&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f54ea346",
  null
  
)

export default component.exports